import { styled, Button } from "@mui/material";

export const LARGE_BUTTON_STYLES = {
  width: "296px",
  height: "72px",
  marginBottom: "16px",
};

export const LargeButton = styled(Button)(LARGE_BUTTON_STYLES);
